var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.styleType === "for-kiko"
        ? [
            _c(
              "CouponKiko",
              _vm._g(
                _vm._b({}, "CouponKiko", _vm.$attrs, false),
                _vm.$listeners
              )
            ),
          ]
        : _vm.styleType === "for-joychat"
        ? [
            _c(
              "CouponJoychat",
              _vm._g(
                _vm._b({}, "CouponJoychat", _vm.$attrs, false),
                _vm.$listeners
              )
            ),
          ]
        : _vm.styleType === "for-echo"
        ? [
            _c(
              "CouponEcho",
              _vm._g(
                _vm._b({}, "CouponEcho", _vm.$attrs, false),
                _vm.$listeners
              )
            ),
          ]
        : [
            _c(
              "CouponVava",
              _vm._g(
                _vm._b({}, "CouponVava", _vm.$attrs, false),
                _vm.$listeners
              )
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }